<template lang='pug'>
  v-container.pa-0(fill-height='', fluid='', grid-list-xl='')
    v-layout(wrap='')
      v-col(cols='12' md='12' style="padding: 0px;").pt-0
        v-card.overflow-hidden.mt-0
          v-app-bar(style='z-index: 999;' color="" dark="" shrink-on-scroll=""  src="../../../assets/login.jpg" fade-img-on-scroll="" scroll-target="#scrolling-techniques-3")
          v-tabs()
            v-tab
              v-icon(left='') mdi-account
              |         VIRTUAL SHOP
            v-tab
              v-icon(left='') mdi-lock
              |         Option 2
            v-tab-item
              v-card(flat='')
                v-row(no-gutters="")
                  v-col(cols="12" md="4")
                    v-card.my-0
                      v-card-text
                        v-row
                          v-col(cols="12" md="6")
                            v-switch(v-model='switch1' :label='`View: ${switch1 === true ? "MAP" : "CARDS"}`')
                          v-col(cols="12" md="6")
                            v-checkbox.mx-2(v-model='showAll' label='Show All' @change="showAllMethod()")
                          v-col(cols="12" md="12")
                            gmap-autocomplete(@place_changed="setPlace" :options="autocompleteOptions").mt-7.location-input
                          v-col(cols="12" md="12")
                            <!--v-autocomplete(v-model="category" :items="categories" color="secondary" label="Category*" validate-on-blur="" @input="search")-->
                            v-select(:items='mainCategories', item-text='data' return-object label='Main Categories' v-model="mainCategorieSelect" @change="changeMainCategorie()")
                          v-col(cols="12" md="12")
                            v-text-field(style="padding: 0px; margin: 0px;" v-model="searchTable" append-icon="mdi-magnify" label="Search Name" single-line="" hide-details="")
                          v-col(cols="12" md="12" style="padding-left: 30px; padding-bottom: 30px;")
                            h4() Scope
                          v-col(cols="12" md="12" style="padding-left: 30px;")
                            v-subheader.pl-0
                              v-slider(v-model="rangeShop" thumb-label="always" :max="10" @change="changeScope()")
                    v-card.mt-1
                      v-card-title
                        | Results
                        v-spacer
                        v-text-field(v-model="searchTable" append-icon="mdi-magnify" label="Search" single-line="" hide-details="")
                      v-data-table(:headers="headers" :items="markers" :search="searchTable" :items-per-page="5" @click:row="openInfoWindow" style="padding-left: 10px;")
                  v-col(cols="12" md="8" style="min-height: 500px;" v-if="!switch1")
                    gmap-map(:center="center" :zoom="zoom" style="width:100%;  height: 100%;" :options="option")
                      gmap-marker(:key="index" v-for="(m, index) in markers" :animation="2" :position="m.position" :clickable="true" @click="openInfoWindow(m)")
                      gmap-info-window(:options="infoOptions" :position="infoContent.position" :opened="infoWinOpen" @closeclick="infoWinOpen=false" style="padding: 0px;")
                        v-row
                          v-col
                            div(style="height: 300px;")
                              img(:src="infoContent.data.img == undefined ? imgShopDefault : infoContent.data.img.imageInput1" class="img-card")
                              v-btn(fab small color="info" class="btn-card")
                                v-icon(small='') mdi-cart
                            v-card-title.mt-1 {{infoContent.data.name}}
                            v-card-text
                              .mt-1.subtitle-1(style="padding: 2px;")
                                v-icon(small='') mdi-content-copy
                                | {{infoContent.data.id}}
                              .mt-1.subtitle-1(style="padding: 2px;")
                                v-icon(small='') mdi-contacts
                                | {{infoContent.data.uid}}
                              .mt-1.subtitle-1(style="padding: 2px;")
                                v-icon(small='') mdi-map-marker
                                | {{infoContent.data.address}} | {{infoContent.data.addressgoogle}}
                              .mt-1.subtitle-1(style="padding: 2px;" v-for="(c, index) in infoContent.data.categories")
                                v-icon(small='') mdi-content-copy
                                  | {{c.name}}
                                <!--v-row-->
                                  <!--v-col(cols="6")-->
                                  <!--v-col(cols="6" v-if="index == 0")-->
                                    <!--img(:src="c.pictures.imageInput1" style="width: 50px;")-->
                  v-col(cols="12" md="8" style="min-height: 500px;" v-if="switch1")
                    v-row
                      v-col( cols="12" md="6" :key="index" v-for="(m, index) in markers" style="padding: 0px 0px 10px 20px;")
                        v-card.mx-auto(d-inline-block style="margin: 0px; height: 510px;")
                          v-card-text.text--primary
                            div(style="height: 300px; min-height: 300px;")
                              img(:src="m.data.img == undefined ? imgShopDefault : m.data.img.imageInput1" class="img-card")
                              v-btn(fab small color="info" class="btn-card")
                                v-icon(small='') mdi-cart
                            v-card-title.mt-1 {{m.data.name}}
                            v-card-text
                              .mt-1.subtitle-1(style="padding: 2px;")
                                v-icon(small='') mdi-content-copy
                                | {{m.data.id}}
                              .mt-1.subtitle-1(style="padding: 2px;")
                                v-icon(small='') mdi-contacts
                                | {{m.data.uid}}
                              .mt-1.subtitle-1(style="padding: 2px;")
                                v-icon(small='') mdi-map-marker
                                | {{m.data.address}} | {{m.data.addressgoogle}}
                              .mt-1.subtitle-1(style="padding: 2px;" v-for="(c, index) in infoContent.data.categories")
                                v-icon(small='') mdi-content-copy
                                  | {{c.name}}
                    .text-center
                      <!--v-pagination(v-model='page' :length='6')-->
            v-tab-item
              v-card(flat='')
                v-card-text
                  p
                    | Morbi nec metus. Suspendisse faucibus, nunc et pellentesque egestas, lacus ante convallis tellus, vitae iaculis lacus elit id tortor. Sed mollis, eros et ultrices tempus, mauris ipsum aliquam libero, non adipiscing dolor urna a orci. Curabitur ligula sapien, tincidunt non, euismod vitae, posuere imperdiet, leo. Nunc sed turpis.
                  p
                    | Suspendisse feugiat. Suspendisse faucibus, nunc et pellentesque egestas, lacus ante convallis tellus, vitae iaculis lacus elit id tortor. Proin viverra, ligula sit amet ultrices semper, ligula arcu tristique sapien, a accumsan nisi mauris ac eros. In hac habitasse platea dictumst. Fusce ac felis sit amet ligula pharetra condimentum.
                  p
                    | Sed consequat, leo eget bibendum sodales, augue velit cursus nunc, quis gravida magna mi a libero. Nam commodo suscipit quam. In consectetuer turpis ut velit. Sed cursus turpis vitae tortor. Aliquam eu nunc.
                  p
                    | Etiam ut purus mattis mauris sodales aliquam. Ut varius tincidunt libero. Aenean viverra rhoncus pede. Duis leo. Fusce fermentum odio nec arcu.
                  p.mb-0
                    | Donec venenatis vulputate lorem. Aenean viverra rhoncus pede. In dui magna, posuere eget, vestibulum et, tempor auctor, justo. Fusce commodo aliquam arcu. Suspendisse enim turpis, dictum sed, iaculis a, condimentum nec, nisi.
</template>

<script>
  /* eslint-disable */
  import axios from 'axios'
  export default {
    data () {
      return {
        imgShopDefault: '../../../assets/images/island.jpg',
        showAll: false,
        mainCategorieSelect: {},
        mainCategories: [],
        switch1: false,
        rangeShop: 1,
        timeout: null,
        zoom: 16,
        center: {lat: 37.0902405, lng: -95.7128906},
        category: '',
        markers: [],
        markersComplete: [],
        chip: 0,
        preset: 'today',
        currentPlace: null,
        option: {
          zoomControl: true,
          mapTypeControl: true,
          scaleControl: true,
          streetViewControl: true,
          rotateControl: true,
          fullscreenControl: true,
          disableDefaultUi: true,
        },
        autocompleteOptions: {
          componentRestrictions: {
            country: [
              'co',
            ],
          },
        },
        categories: [
          'Vandalism',
          'Home invasion',
          'Crimes',
          'Historic events',
          'Humanitarian',
          'Unusual vacation spots',
        ],
        infoContent: {
          position: {
            lat: '4.6097224',
            lng: '-83.395109',
          },
          data: {
            location: ''
          }
        },
        infoWinOpen: false,
        //optional: offset infowindow so it visually sits nicely on top of our marker
        infoOptions: {
          pixelOffset: {
            width: 0,
            height: -35
          }
        },
        searchTable: '',
        headers: [
          { text: 'Name', value: 'data.name'},
          { text: 'Address', value: 'data.addressgoogle' },
          { text: 'Categorie', value: 'data.mainCategorie.data' },
        ],
        headersInventory: [
          { text: 'Name', value: 'data.name'},
          { text: 'Price', value: 'data.price.sale' },
        ],
      }
    },

    mounted () {
      this.imgShopDefault = '../../../assets/images/island.jpg'
      const vm = this
      vm.geolocate()
      this.$store.dispatch('shops/getMainCategories', 'en').then(res => {
        if (res) {
          this.mainCategories = res
        }
      })
      
    },

    methods: {
      changeScope () {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.search(this.center.lat, this.center.lng)
        }, 1000, 'JavaScript')
      },
      keyUpSearchShopName () {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {

        }, 1000, 'JavaScript')
      },
      showAllMethod(){
        this.markers = this.markersComplete
      },
      changeMainCategorie () {
        // console.log(this.mainCategorieSelect)
        this.markers = this.markersComplete.filter(
          item => {
            return item.data.mainCategorie.id == this.mainCategorieSelect.id
          });
        this.showAll = false
      },
      setPlace (place) {
        this.zoom = 13
        const vm = this
        vm.center = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
        }
        vm.currentPlace = place
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          vm.search(vm.center.lat, vm.center.lng)
        }, 1000, 'JavaScript')
      },

      geolocate: function () {
        const vm = this
        navigator.geolocation.getCurrentPosition(position => {
          vm.center = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          }
          vm.search(vm.center.lat, vm.center.lng)
        })
      },

      setMarkers (results) {
        const vm = this
        vm.markers = []
        results.forEach(element => {
          const marker = element.data.dataShop.location
          const inventory = []
          this.markers.push({ position: marker, data: element.data.dataShop, inventory: inventory })
          // const marker = element.data.dataShop.location
          // const uid = element.data.dataShop.uid
          // this.$store.dispatch('shops/getUserInventory', uid).then(res => {
          //   if (res) {
          //     const inventory = res
          //     this.markers.push({ position: marker, data: element.data.dataShop, inventory: inventory })
          //   } else {
          //     const inventory = []
          //     this.markers.push({ position: marker, data: element.data.dataShop, inventory: inventory })
          //   }
          // })
        });
        this.markersComplete = this.markers
        // console.log(this.markers)
      },

      search (lat, lng) {
        const vm = this
        const data = {
          lat: lat,
          lng: lng,
          distance: this.rangeShop
        }
        this.$store.dispatch('shops/getVirtualShopData', data).then(res => {
          if (res) {
            // console.log(res)
            vm.setMarkers(res.data)
          }
        })
        // this.$store.dispatch('shops/getVirtualShopList').then(res => {
        //   if (res) {
        //     // console.log(res)
        //     vm.setMarkers(res)
        //   }
        // })
        // axios.post('https://us-central1-scene-finder-3cb7a.cloudfunctions.net/searchMedia', requestData).then(res => {
        //   // console.log(res)
        //   vm.setMarkers(res.data)
        // }).catch(e => {
        //   // console.log(e)
        // })
      },

      openInfoWindow (marker) {
        // console.log('aqui', marker)
        const vm = this
        vm.center = marker.position
        vm.zoom = 20
        vm.infoContent = marker
        vm.infoWinOpen = true
        // console.log(vm.infoContent)
      }
    },
  }
</script>

<style scoped>
  .btn-card {
    left: 80%;
    top: -20px;
  }
  .img-card {
    max-width: 100%;
    max-height: 100%;
    display: block;
    width: 100%;
    min-height: 300px;
  }
  #map{
    height: 600px;
  }
  .location-input{
    width: 100%;
    border-bottom: 1px solid #d2d2d2;
  }
</style>
